
import { Component, Vue } from 'vue-property-decorator';
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import LayoutPublic from '@/layouts/LayoutPublic.vue';
import Hero from '@/components/Hero.vue';

@Component({
  components: { LayoutDefault, LayoutPublic, Hero },
})
export default class ErrorPage extends Vue {
  statusCode = 404;

  get layout(): string {
    return this.$store.getters['auth/signedIn']
      ? 'LayoutDefault'
      : 'LayoutPublic';
  }

  message(element: string): string {
    const transKey = `error.error_${this.statusCode}.${element}`;
    if (this.$te(transKey)) {
      return this.$t(transKey) as string;
    }
    if (this.$te(`error.general.${element}`)) {
      return this.$t(`error.general.${element}`) as string;
    }
    return '';
  }
}
